<template>
<div class="conter_section" @scroll.passive="handleScroll">
    <div class="container">
       <div class="row" >
        <template  v-for="(counter,index) in get_counter_list">
               <div class="col-4" :key="counter.id">
            <div class="box_count">
                <div class="title_count">
                     <number
                        :class="`number${index+1} nums_c`"
                        :ref="`number`"
                        :animationPaused="true"
                        :from="0"
                        :to="counter.value"
                        :duration="1.5"
                        :delay="0.5"
                        easing="Power1.easeOut"/>
                    <span class="sp_plus">+</span>
                </div>
                <div class="desc_count">{{counter.key}}</div>
            </div>
        </div>
        </template>
       </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
 import $ from 'jquery';
export default {
  name: "counterArea",
  data(){
    return{}
  },
   computed:{
    ...mapGetters({
        get_counter_list:'get_counter_list',
    })
   },
  
  methods:{
    handleScroll(e) {
    var offset = Math.round($(".conter_section").offset().top-800);
    if(e.target.documentElement.scrollTop >= offset){
          this.play_count();
    }
  },
        play_count(){
            this.$refs.number.forEach(element => {
                element.play();
            });
        },
         ...mapActions({
       counter_api:'counter_api',
    }),
  },
  mounted(){
    this.counter_api().then(()=>{
        window.addEventListener("scroll", this.handleScroll);
    });
  },
  beforeDestroy() {
  window.removeEventListener("scroll", this.handleScroll)
},
}
</script>
<style lang="scss" scoped>
.box_count{
    padding-top: 60px;
    text-align: center;
    .title_count{
    font-family: "Oswald", Sans-serif;
    font-size: 64px;
    color: white;
    font-weight: 600;
    line-height: 1;
    }
    .nums_c{
        font-family: "Oswald", Sans-serif;
    }
    .desc_count{
            font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 4em;
    letter-spacing: 2px;
    text-align: center;
    color: #d8d8d8;
    font-family: 'Roboto', sans-serif;
    }
}
.sp_plus{
    margin-left: 0px;
        font-family: "Oswald", Sans-serif;
    // color: var(--active_color);
}


// STYLE MEDIA QUERY
@media(max-width:992px){
  .box_count .title_count {
    font-size: 50px;
}
.box_count .desc_count {
    font-size: 11px;
}
.box_count{
    padding-top: 60px;
    text-align: center;
    margin-bottom: 60px;
}
}

@media(max-width:767px){
    .box_count .title_count{
    font-size: 30px;
}
.sp_plus {
    margin-left: 0px;
    font-family: "Oswald", Sans-serif;
    font-size: 25px;
}
}
</style>